const SUB_STEPS = [
  { number: 1, title: "Technical Round" },
  { number: 2, title: "Focus Area" },
  { number: 3, title: "Weightage" },
  { number: 4, title: "Requirements Gathering" },
];

const SubStepBreadcrumb = ({ activeIndex, onStepClick }) => (
  <div className="flex items-center">
    {SUB_STEPS.map((step, index) => {
      const isVisited = index < activeIndex;
      return (
        <div key={step.number} className="flex items-center">
          <span
            className={`text-sm ${
              isVisited
                ? "text-[#069855] cursor-pointer hover:underline"
                : index === activeIndex
                ? "dark:!text-white !text-textPrimary font-semibold"
                : "text-[#575B72]"
            }`}
            onClick={() => isVisited && onStepClick?.(index)}
          >
            {step.title}
          </span>
          {index < SUB_STEPS.length - 1 && (
            <div className="flex items-center mx-6">
              <span className="text-[#8893C8] text-sm">{">>"}</span>
            </div>
          )}
        </div>
      );
    })}
  </div>
);

export default SubStepBreadcrumb;
